export default __webpack_public_path__ + "static/media/copyToClipboard.60f025ed.svg";